import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { resetAnalytics } from './utils/analytics';
import { initializeAuth, handleLogin } from './auth/authService';

interface AuthState {
  isAuthenticated: boolean;
  token: string | null;
  username: string | null;
  login: (token: string, username: string) => void;
  logout: () => void;
}

type AuthStore = (
  set: (state: Partial<AuthState> | ((state: AuthState) => Partial<AuthState>)) => void,
  get: () => AuthState
) => AuthState;

export const useAuth = create<AuthState>()(
  persist(
    ((set) => ({
      ...initializeAuth(null),
      login: (token: string, username: string) => {
        set(handleLogin(token, username));
      },
      logout: () => {
        localStorage.removeItem('auth_token');
        resetAnalytics(true);
        set({ isAuthenticated: false, token: null, username: null });
      },
    })) as AuthStore,
    {
      name: 'auth-storage',
      onRehydrateStorage: () => (state) => {
        // Re-initialize auth on storage rehydration
        if (state) {
          const authState = initializeAuth(state.username);
          if (state) {
            Object.assign(state, authState);
          }
        }
      },
    }
  )
);